var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoPlayerDemoWrapper',[_c('video-player-core',[_c('div',{style:({
        position: 'absolute',
        top: 0,
        color: 'black',
        backgroundColor: 'white',
        padding: '4em',
      })},[_vm._v(" Default slot example ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }